import { render } from "./NewStarterFormAction.vue?vue&type=template&id=9725eae0&scoped=true&ts=true"
import script from "./NewStarterFormAction.vue?vue&type=script&lang=ts"
export * from "./NewStarterFormAction.vue?vue&type=script&lang=ts"

import "./NewStarterFormAction.vue?vue&type=style&index=0&id=9725eae0&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9725eae0"]])

export default __exports__